import { createAction } from '@reduxjs/toolkit';

const toggleRecursiveSearch = createAction('archive/toggleRecursiveSearch');

export default toggleRecursiveSearch;
